import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Grid from 'react-bootstrap/lib/Grid';
import Alert from 'react-bootstrap/lib/Alert';
import Button from 'react-bootstrap/lib/Button';

import { redirect } from 'widgets/I18nLink';
import { loadOrder, acceptOrder, declineOrder } from 'actions';
import { allCitiesSelector, bikeTypesSelector } from 'selectors';
import Preloader from 'widgets/Preloader';
import { toCityTimezone } from '../../../utils/dates';

import './order-confirm.css';

const dateTimeFormat = 'D MMMM YYYY H:mm';

class OrderConfirmPage extends Component {
  componentWillMount() {
    this.props.loadOrder(this.props.params.orderUid);
  }

  componentDidMount() {
    setTimeout(() => {
      if (!this.props.isAuthorized) {
        redirect(`/accounts/register/?next=${this.props.location.pathname}`);
        return;
      }
    }, 1000);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.orderUid !== this.props.orderUid) {
      this.props.loadOrder(nextProps.params.orderUid);
    }
  }

  acceptOrder = () => {
    this.props.acceptOrder(this.props.params.orderUid);
    redirect('/');
  }

  declineOrder = () => {
    this.props.declineOrder(this.props.params.orderUid);
    redirect('/');
  }

  render() {
    const { t, cities, bikeTypes, order: { isFetching, item: order } } = this.props;

    const city = order && (cities.find(city => city.id === order.city));
    const bikeType = order && (bikeTypes.find(bt => bt.id === order.bikeType));


    let beginTime;
    let endTime;

    if (order) {
      beginTime = toCityTimezone(order.beginTimeTz, city).format(dateTimeFormat);
      endTime = toCityTimezone(order.endTimeTz, city).format(dateTimeFormat);
    }

    return (
      <div className="order-confirm-page">
        <Grid>
          <div className="order-confirm-box">
            {(isFetching) &&
              <Preloader cubeStyle={{ backgroundColor: '#5080c5' }} />
            }

            {(order) &&
              <div className="order-confirm">
                <h2>{t('Please confirm or decline order')}</h2>

                <Alert bsStyle="info">
                  <h3>
                    {t('Booking number')}:{' '}
                    <span className="highlight booking-uid">
                      {order.uid}
                    </span>
                  </h3>

                  <p>
                    {t('Client has booked a')} <span className="highlight">
                      {t(bikeType.nameEn, { ns: 'bikeTypes' })}
                    </span>{' '}
                    {t('in')} <span className="highlight">
                      {city && t(city.nameEn, { ns: 'cities' })}
                    </span>{' '}
                    {t('from')} <span className="highlight">
                      {beginTime}
                    </span>{' '}
                    {t('to')} <span className="highlight">
                      {endTime}
                    </span>
                  </p>
                </Alert>

                <div className="order-confirm-buttons">
                  <Button bsStyle="danger" onClick={this.acceptOrder}>Confirm</Button>
                  <Button bsStyle="default" onClick={this.declineOrder}>Decline</Button>
                </div>

                <div className="text-left">
                  <p>
                    {t('If you have any questions, please send us an email at')}{' '}
                    <a href={`mailto:${this.props.contactEmail}`}>{this.props.contactEmail}</a>
                  </p>
                </div>
              </div>
            }
          </div>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthorized: !!state.profile.profile.id,
    order: state.order.order,
    contactEmail: state.app.siteConfig.contactEmail,
    cities: allCitiesSelector(state),
    bikeTypes: bikeTypesSelector(state)
  };
}

export default connect(
  mapStateToProps,
  { loadOrder, acceptOrder, declineOrder }
)(translate(['translation'])(OrderConfirmPage));



// WEBPACK FOOTER //
// ./src/components/CompanyApp/OrderConfirmPage/index.js